import { Box, ImageWithButton } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useAgency from '@hooks/useAgency'

import { AgencyModel } from '@models/types'

import placeholderImageUrl from './assets/agencyImagePlaceholder.svg'

interface AgencyImagesProps {
  agency: AgencyModel,
}

const AgencyImages = (props: AgencyImagesProps) => {
  const { agency } = props

  const agencyPaylaod = useAgency(agency)
  const {
    callbacks: { manageAgencyImages },
  } = agencyPaylaod

  const defaultImageUrl = digObject(agency, 'default_image')

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderTopLeftRadius={5}
      borderTopRightRadius={5}
      flexDirection="column"
    >
      <ImageWithButton
        // @ts-expect-error TS2322
        onClick={() => manageAgencyImages({
          image_type: 'photo',
          imageable_id: agency.id,
          imageable_type: 'Agency',
        })}
        placeholderUrl={placeholderImageUrl}
        url={defaultImageUrl}
      />
    </Box>
  )
}

export default AgencyImages
